import React from 'react';
import {Select} from "antd";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

const LogRecord = () => {
    return (
        <div className="main-padding  ">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>Comparison Record</span>
            </div>

            <div className="camera-config-content">
                <h5 className="text-white">
                    Log File Query
                </h5>
                <div className="row mt-3 d-flex align-items-center">
                    <div className="col-md-2 text-white text-end">
                        Log selection
                    </div>
                    <div className="col-md-3">
                        <div className="input-group d-flex flex-nowrap w-100">
                            <Select className="w-100">
                                <option value="1">option</option>
                            </Select>
                            <button className="btn btn-primary">
                                <img src="/icon/loupe.png" alt="."/>
                            </button>
                        </div>

                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-success">
                            <img src="/icon/downloads.png" alt="..."/>
                        </button>
                    </div>
                </div>
                <div className="row mt-3 d-flex  ">
                    <div className="col-md-2 text-white text-end">
                        Log content
                    </div>
                    <div className="col-md-3 input-boxs">
                        <textarea className="form-control text-white" style={{background: "#0E1621"}} cols="20" rows="5"></textarea>
                    </div>
                </div>
            </div>

            <div className="camera-config-content">
                <h5 className="text-white">
                    System Log Query
                </h5>

                <div className="control-header-cmcf my-avform mt-4">
                    <div className="d-flex align-items-center">
                        <label className="text-white mr-16 ">Log Type</label>
                        <Select

                            placeholder="Поиск, чтобы выбрать"
                            optionFilterProp="children"

                        >
                            <option value="1">All type</option>
                            <option value="3">Probe alarm</option>
                            <option value="3">Motion detection</option>
                            <option value="2">Motor alarm</option>
                        </Select>
                        <input type="datetime-local" className="p-2 ml-8"/>
                        <span className="text-white ml-8 mr-8">to</span>
                        <input type="datetime-local"  className="p-2   mr-16"/>

                        <button className="btn btn-success ml-24"  ><img src="/icon/loupe.png" className="mr-8" alt="..."/>Search</button>
                        <button className="btn btn-success ml-8" >Device log download</button>
                    </div>
                </div>

                <div className="emp-table mt-4">
                    <TableContainer component={Paper}>
                        <Table sx={{minWidth: 650}} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className="pl20 table-head" align="left">#</TableCell>

                                    <TableCell className="table-head" align="left">Time</TableCell>
                                    <TableCell className="pr20 table-head" align="right">
                                        Detail
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell className="pl20 text-white" component="th" scope="row">
                                        1
                                    </TableCell>

                                    <TableCell className="text-white" align="left">device_name</TableCell>
                                    <TableCell className="text-white" align="right">device_name</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </div>
    );
};

export default LogRecord;